import * as React from 'react';
export const suiSvg = React.forwardRef(function suiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#4498FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M20.803 14.34a5.883 5.883 0 0 1 1.333 3.73 5.923 5.923 0 0 1-1.37 3.773l-.074.09-.02-.113a5.25 5.25 0 0 0-.059-.29c-.428-1.843-1.826-3.423-4.125-4.702-1.553-.862-2.442-1.899-2.675-3.078-.151-.762-.04-1.528.177-2.184.217-.655.539-1.205.813-1.535l.894-1.07a.398.398 0 0 1 .608 0l4.498 5.38Zm1.415-1.068-5.996-7.17a.29.29 0 0 0-.444 0l-5.995 7.17-.02.024A7.668 7.668 0 0 0 8 18.189C8 22.503 11.582 26 16 26s8-3.497 8-7.811a7.66 7.66 0 0 0-1.764-4.893l-.019-.023v-.001Zm-11 1.046.536-.642.016.118c.013.094.029.188.047.283.347 1.78 1.587 3.265 3.659 4.414 1.801 1.003 2.85 2.156 3.152 3.42a4.3 4.3 0 0 1 .094 1.5l-.004.029-.026.012a6.239 6.239 0 0 1-2.693.606c-3.388 0-6.135-2.68-6.135-5.99a5.88 5.88 0 0 1 1.352-3.752l.002.002Z',
      fill: '#fff',
    }),
  );
});
suiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sui = {
  category: 'brand',
  colorable: false,
  name: 'sui',
  svg: suiSvg,
};
